import { Routes, Route, Navigate } from 'react-router';
import { useAuth } from '@/hooks/useAuth';
import { ProtectedRoute } from '@/components/features/auth/ProtectedRoute';
import { AppShell } from '@/components/layout/AppShell';
import { Login } from '@/pages/Login';
import { DoctorDashboard } from '@/pages/doctor/Dashboard';
import { Patients } from '@/pages/doctor/Patients';
import { PatientDetail } from '@/pages/doctor/PatientDetail';
import { DoctorDownload } from '@/pages/doctor/Download';
import { DoctorDownloadRaw } from '@/pages/doctor/DownloadRaw';
import { DoctorRTPDownload } from '@/pages/doctor/RTPDownload';
import { PatientDashboard } from '@/pages/patient/Dashboard';
import { PatientActivities } from '@/pages/patient/Activities';
import { PatientRawDownload } from '@/pages/patient/RawDownload';
import { PatientRTPDownload } from '@/pages/patient/RTPDownload';

function App() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        path="/doctor"
        element={
          <ProtectedRoute allowedRoles={['doctor']}>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<DoctorDashboard />} />
        <Route path="patients" element={<Patients />} />
        <Route path="patients/:patientId" element={<PatientDetail />} />
        <Route path="download" element={<DoctorDownload />} />
        <Route path="download-raw" element={<DoctorDownloadRaw />} />
        <Route path="rtp-download" element={<DoctorRTPDownload />} />
      </Route>

      <Route
        path="/patient"
        element={
          <ProtectedRoute allowedRoles={['patient', 'nushu-x']}>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<PatientDashboard />} />
        <Route path="activities" element={<PatientActivities />} />
        <Route path="download-raw" element={<PatientRawDownload />} />
        <Route path="rtp-download" element={<PatientRTPDownload />} />
      </Route>

      <Route
        path="/"
        element={
          user ? (
            <Navigate
              to={user.role === 'doctor' ? '/doctor' : '/patient'}
              replace
            />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
